<template>
    <b-button
        :type="type"
        :variant="variant"
        :size="size"
        :disabled="disabled"
        class="btn-loader"
        @click="$emit('click', $event)"
        :class="className"
        :block="block"
    >
        <span v-if="loader">
            <i class="fa fa-spinner fa-spin"></i>
        </span>
        <span v-else>
            <slot />
        </span>
    </b-button>
</template>

<script>
export default {
    name: 'ButtonLoader',
    props: [
        'content',
        'variant',
        'size',
        'type',
        'disabled',
        'loader',
        'className',
        'block',
    ],
}
</script>

<style scoped>
.btn-loader {
    min-width: 50px;
}
</style>
